module.exports = __webpack_public_path__ + "static/img/t1-4.9a8925e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/t1-4.png
// module id = QMcu
// module chunks = 1